import { render } from "./AudienceOwners.vue?vue&type=template&id=90b5072a"
import script from "./AudienceOwners.vue?vue&type=script&lang=js"
export * from "./AudienceOwners.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__